// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
import invoiceApi from '~/apis/invoice';
// Others
import {
  CHANGE_STATUS_INVOICE,
  CREATE_INVOICE,
  GET_INVOICE_DETAILS,
  GET_LIST_INVOICE,
  SEND_INVOICE,
} from '~/utils/constants/actionType';
import {
  IChangeStatusInvoiceBody,
  IQueryCreateInvoice,
  IQueryGetInvoiceDetails,
  IQueryParamInvoice,
  ISendInvoiceBody,
} from '~/utils/interface/invoice';

export const getInvoiceList = createAsyncThunk(
  GET_LIST_INVOICE,
  async (params: IQueryParamInvoice, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.getInvoiceList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createInvoice = createAsyncThunk(
  CREATE_INVOICE,
  async (body: IQueryCreateInvoice, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.createInvoice(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getInvoiceDetails = createAsyncThunk(
  GET_INVOICE_DETAILS,
  async (params: IQueryGetInvoiceDetails, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.getInvoiceDetails(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeStatusInvoice = createAsyncThunk(
  CHANGE_STATUS_INVOICE,
  async (params: IChangeStatusInvoiceBody, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.changeStatus(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendInvoice = createAsyncThunk(
  SEND_INVOICE,
  async (params: ISendInvoiceBody, { rejectWithValue }) => {
    try {
      const resp = await invoiceApi.sendInvoice(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
